/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';

const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
};

/** Utilities layer overrides component-layer padding from btn-* when present. */
const SIZE_CLASS = {
  sm: 'px-3 py-1 text-sm',
  md: '',
};

function mergeClass(...parts) {
  return parts.filter(Boolean).join(' ');
}

/**
 * Shared button for Loc'd In. Visual styles live on `.btn-*` in index.css;
 * this component applies them and supports links via `to` or `as`.
 *
 * @param {'primary'|'secondary'|'outline'} variant
 * @param {'sm'|'md'} size: md uses global btn padding (default compact)
 */
export default function Button({
  as,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  disabled,
  to,
  children,
  ...rest
}) {
  const classes = mergeClass(VARIANT_CLASS[variant], SIZE_CLASS[size], className);

  if (to != null) {
    return (
      <Link className={classes} to={to} {...rest}>
        {children}
      </Link>
    );
  }

  const Comp = as || 'button';
  const compProps = Comp === 'button' ? { type, disabled } : { disabled };

  return (
    <Comp className={classes} {...compProps} {...rest}>
      {children}
    </Comp>
  );
}
